module.exports = __webpack_public_path__ + "static/media/image_7.441836b5.jpg";